import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Button, Card, CardContent, TextField, List, ListItem, ListItemText, DialogActions, Divider, Container, FormLabel, Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import GroupedCartPopup from "./modals/groupedCartItems";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const Cart = ({ payload, series, initialCartItems, proceed, setCart, seriesD, editMode, newDataProp, isSpecimen, tntAmount }) => {
  const [cartItems, setCartItems] = useState([]);
  const [discountPopup, setDiscountPopup] = useState(false);
  const [discounts, setDiscounts] = useState({})
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [attachments, setAttachment] = useState("");
  const [tentativeAmount, setTentativeAmount] = useState("");

  // const handleQuantityChange = (index, delta) => {
  //   setCartItems((prevCartItems) => {
  //     return prevCartItems.map((item, i) =>
  //       i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
  //     );
  //   });


  //   let id = cartItems[index].itemId
  //   let temp = [...initialCartItems]
  //   for (let i = 0; i < temp.length; i++) {
  //     if (temp[i].data.skuId == id) {
  //       temp[i].quantity = Math.max(1, temp[i].quantity + delta)
  //       break;
  //     }
  //   }
  //   setCart(temp)
  // };
  const handleQuantityChange = (index, delta) => {
  setCartItems((prev) => {
    const updated = prev.map((item, i) =>
      i === index ? { ...item, qty: Math.max(1, item.qty + delta) } : item
    );

    const id = updated[index].itemId;

    const temp = initialCartItems.map((item) =>
      item.data.skuId === id
        ? { ...item, quantity: Math.max(1, item.quantity + delta) }
        : item
    );

    setCart(temp);
    return updated;
  });
};


  // const handleRemoveItem = (index) => {
  //   setCartItems((prevCartItems) => prevCartItems.filter((_, i) => i !== index));
  //   let id = cartItems[index].itemId
  //   let temp = []
  //   for (let i = 0; i < initialCartItems.length; i++) {
  //     if (initialCartItems[i].data.skuId != id) {
  //       temp.push(initialCartItems[i])
  //       break;
  //     }
  //   }

  //   setCart(temp)
  // };
  const handleRemoveItem = (index) => {
  const id = cartItems[index].itemId;

  setCartItems((prev) => prev.filter((_, i) => i !== index));

  const temp = initialCartItems.filter(
    (item) => item.data.skuId !== id
  );

  setCart(temp);
};


  const getTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.qty) * (1 - item.discount / 100), 0);
  };

  function setData() {
    const newCartItems = [];

    initialCartItems.forEach((order) => {
      const quantity = parseInt(order.quantity, 10) || 1;
      const group = order.group;
      const item = order.data || {};

      newCartItems.push({
        name: item?.nameSku,
        // name: group === "6HPipXSLx5" ? item.product_name : item.nameSku,
        productGroup: group,
        price:
          item.unitPrice != null
            ? parseFloat(item.unitPrice)
            : parseFloat(item.landing_cost) || 0.0,
        qty: quantity,
        series: item.seriesCategory || "",
        itemId: item.skuId || item.id,
        total: item.unitPrice != null ? (parseFloat(item.unitPrice) * quantity || 0.0) : 0.0,
        discount: item.discount ? item.discount:0,
        itemType: order.orderType,
      });
    });

    setCartItems(newCartItems);
  }
  
  useEffect(() => { setData() }, [])

  // Initialize discounts from `seriesD` prop (may be JSON string or object)
  useEffect(() => {
    if (seriesD) {
      let parsed = seriesD;
      if (typeof seriesD === 'string') {
        try {
          parsed = JSON.parse(seriesD);
        } catch (e) {
          parsed = {};
        }
      }
      setDiscounts(parsed || {});
    }
  }, [seriesD]);

  // When discounts change, apply them to cart items so payload will include updated values
  useEffect(() => {
    if (cartItems.length === 0) return;
    setCartItems((prev) =>
      prev.map((item) => ({ ...item, discount: discounts[item.series] ?? item.discount ?? 0 }))
    );
  }, [discounts]);

  useEffect(()=>{
    setTentativeAmount(tntAmount || "")
    console.log(newDataProp,"newDataPropnewDataProp",payload, series, initialCartItems, proceed, setCart, seriesD, editMode,tntAmount)
  },[editMode])

  function applyD(discountsObj) {
    let temp = [...cartItems];
    temp.forEach((ele) => {
      ele.discount = discountsObj[ele.series] ?? 0;
    });
    setDiscountPopup(false);
    setCartItems(temp);
    // Persist the discounts mapping in component state so payloadCreate picks it up
    setDiscounts(discountsObj || {});
  }

  function payloadCreate() {
    if(!editMode && payload?.orderProcess == "upload" && (payload?.orderType?.toLowerCase() == "specimen" || payload?.orderType==="Sales" || payload?.orderType==="saleS") && attachments == "") {
      alert("Please upload attachment before proceeding.")
      return;
    }
    var body = { ...payload };
    body['totalAmount'] = body['orderType'].toLowerCase() == 'sales' ? getTotalPrice() : 0;
    body['seriesDiscount'] = discounts;
    body['attachments'] = attachments;
    body['tentativeAmount'] = tentativeAmount;
    body['orders'] = cartItems.map((item) => {
      return {
        'itemId': item.itemId,
        'name': item.name,
        'price': item.price,
        'qty': item.qty,
        'productGroup': item.productGroup,
        'orderType': item.itemType ?? "",
        'total': payload['orderType'].toLowerCase() == 'sales' ? item.price * item.qty * (1 - item.discount / 100) : 0
      };
    });

    console.log(body, "Payload to create order from cart", payload);

    proceed(cartItems, body)
  }

  const getFilePreview = (file) => {
    if (file.type.startsWith('image/')) {
      return <img src={URL.createObjectURL(file)} alt={file.name} style={{ maxWidth: '100%', height: '100px' }} />;
    } else {
      return <InsertDriveFileIcon style={{ fontSize: 50, height: "100px", }} />;
    }
  };

  const handleFileChange = (event) => {
    setFiles([...event.target.files]);
    setOpen(true);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    try {
      const response = await window.Platform.database.uploadMultipleImages(formData);
      if (response) {
        const result = await response
        let temp = [...attachments]
        result.data.files.forEach((ele) => {
          temp.push(ele)
        });
        setAttachment(temp)

        setOpen(false);
      } else {
        alert('Failed to upload files.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Error uploading files.');
    }
  };


  return (
    <Container>

      {newDataProp?.orderProcess == "upload" && <div>
        <FormLabel sx={{ mr: 3, mt:3, fontSize: 14,  }}>Upload Attachment </FormLabel>
        <input type="file" multiple onChange={handleFileChange} />
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>File Preview</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {files.map((file, index) => (
                <Grid item xs={6} key={index}>
                  {getFilePreview(file)}
                  <Typography variant="body2" noWrap>{file.name}</Typography>
                </Grid>
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleUpload} variant="contained" color="primary">Upload</Button>
          </DialogActions>
        </Dialog>

       {payload && payload?.orderType != "Specimen" && <TextField
      //  disabled={editMode ? true : false}
          label="Tentative Amount"
          type="number"
          fullWidth
          value={tentativeAmount}
          onChange={(e) => setTentativeAmount(e.target.value)}
        />}
      </div>
}
      {discountPopup ? <div>


        <GroupedCartPopup
          open={discountPopup}
          onClose={() => setDiscountPopup(false)}
          cartItems={cartItems}
          seriesData={series}
          applyDiscounts={applyD}
          editMode={editMode}
          seriesD={seriesD}
          setDiscountsPer={setDiscounts}
          orderProcess={newDataProp?.orderProcess}
          uploadedSeries = {payload?.uploadSeries}
        />
      </div> :
        <div>

          {/* Cart Items */}
          <List>
            {cartItems.map((item, index) => (
              <Card key={index} sx={{ margin: 2, padding: 1 }}>{console.log(cartItems,"cartItems", item)}
                <CardContent>
                  <ListItem>
                    <ListItemText
                      primary={item.name}
                      secondary={`Total Price: ₹${(item.price * item.qty).toFixed(2)} | Price: ₹${item.price}`}
                    />
                    <IconButton onClick={() => handleQuantityChange(index, -1)}>
                      <Remove />
                    </IconButton>
                    <Typography>{item.qty}</Typography>
                    <IconButton onClick={() => handleQuantityChange(index, 1)}>
                      <Add />
                    </IconButton>
                    <IconButton onClick={() => handleRemoveItem(index)} color="error">
                      <Delete />
                    </IconButton>
                  </ListItem>
                </CardContent>
              </Card>
            ))}
          </List>

          {/* Total & Buttons */}
          <Divider />
          <Typography variant="h6" sx={{ textAlign: "center", marginY: 2 }}>
            Total: ₹{payload.orderType.toLowerCase() === "sales" ? getTotalPrice().toFixed(2) : 0}
          </Typography>
{console.log(payload,"payloadpayload")}
          <div style={{ display: "flex", justifyContent: "space-between", padding: 16 }}>
            {(payload && payload?.orderType != "Specimen" && payload?.applyDiscount == "yes") && <Button variant="contained" color="success" startIcon={<Discount />} onClick={() => setDiscountPopup(!discountPopup)}>
              Discounts
            </Button>}
            <Button variant="contained" color="primary" startIcon={<ArrowForward />} onClick={() => payloadCreate()}>
              Proceed
            </Button>
          </div>
        </div>}
    </Container>
  );
};

export default Cart;